const Navdata = [
  {
    id: 1,
    name: "About Us",
    pathname: "/#aboutus",
  },

  {
    id: 2,
    name: "Food Menu",
    pathname: "/foodmenu",
  },

  {
    id: 3,
    name: "Drinks Menu",
    pathname: "/drinksmenu",
  },

  {
    id: 4,
    name: "Gallery",
    pathname: "/gallery",
  },

  // {
  //   id: 5,
  //   name: "Contact Us",
  //   pathname: "#contactus",
  // },
];

export default Navdata;
